var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cencenlInterview"},[(!_vm.type)?_c('el-button',{attrs:{"round":"","size":_vm.size,"loading":_vm.btnLoading},on:{"click":_vm.cencenlResume}},[_vm._v(_vm._s(_vm.$t("cancelInterview")))]):_c('span',{on:{"click":_vm.cencenlResume}},[_vm._t("btn")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }